/**
 * @Author proudlx
 * @Description http请求接口路径
 */
/** 字典管理 */
export const POST_BASE_DICT_LIST = "/api/base/dictList";
export const POST_BASE_MARKET_PERMISSION_CHECK = "/api/student/marketPermissionCheck";